import axios from "axios";
import { Toast } from "vant";
// import { router } from "../router";
import store from "../store";

// 创建axios实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_API2,
  timeout: 60000, // 请求超时时间
});

// 添加request拦截器
instance.interceptors.request.use((config) => {
  const token = window.$cookies.get("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// 添加respone拦截器
instance.interceptors.response.use(
  (response) => {
    // let res = {};
    // res.status = response.status;
    // res.data = response.data;
    return response;
  },
  (error) => {
    if (error.message === "Network Error") {
      Toast.loading({
        forbidClick: true,
        message: "网络错误，请检查是否联网",
      });
    }
    if (error.message.includes("timeout")) {
      Toast.loading({
        forbidClick: true,
        message: "查询超时，请重试",
      });
    }
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          Toast.fail({
            forbidClick: true,
            message: error.response.data.msg,
          });
          window.$cookies.remove("token");
          window.$cookies.remove("orderNums");
          window.$cookies.remove("getUserInfo");
          window.$cookies.remove("phone");
          store.dispatch("toLogin");
          break;

        case 404:
          Toast.loading({
            forbidClick: true,
            message: "请求出错(404)",
          });
          break;

        case 500:
          Toast.loading({
            forbidClick: true,
            message: "服务器错误(500)",
          });
          break;

        case 400:
          if (error.response.data.msg == "validateToken.token: 不能为空") {
            Toast.fail({
              forbidClick: true,
              message: error.response.data.msg,
            });
            window.$cookies.remove("token");
            window.$cookies.remove("orderNums");
            window.$cookies.remove("getUserInfo");
            window.$cookies.remove("phone");
            store.dispatch("toLogin");
          } else {
            Toast.fail({
              forbidClick: true,
              message: error.response.data.msg,
            });
          }
          break;

        default:
          Toast.loading({
            forbidClick: true,
            message: "连接出错",
          });
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
